import SelectArrowIcon from '../icons/SelectArrowIcon';
import './style.scss';
import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ options, onSelect }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedOption, setSelectedOption] = useState(options[0]);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<div className='custom-dropdown' ref={dropdownRef}>
			<div
				className='dropdown-selected'
				onClick={() => setIsOpen(!isOpen)}
			>
				<SelectArrowIcon className={'arrow-icon'} />
				<span>
					{selectedOption.icon} {selectedOption.label}
				</span>
			</div>
			{isOpen && (
				<div className='dropdown-options'>
					{options.map((option, index) => (
						<div
							key={index}
							className='dropdown-option'
							onClick={() => {
								setSelectedOption(option);
								setIsOpen(false);
								onSelect(option);
							}}
						>
							{option.icon}
							<span>{option.label} </span>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default CustomDropdown;
